<template>
  <div>
    <div class="fc-text-center fc-mar-t-super">
      <!--reallive logo-->
      <img class="logo_img_reallive" src="../../../static/img/realLive.png" v-if="isRealLive()"/>
      <img class="logo_img" src="../../assets/img/logo.png" v-else/>
    </div>
    <!--reallive只展示手机和邮箱两个按钮-->
    <div v-if="isRealLive()" class="login_box">
      <div class="login-btn__reallive" @click="phoneLogin">
        <img class="login_icon__reallive" src="../../assets/img/phone.png" />
        <span>{{$t('m.use_phone_login')}}</span>
      </div>
      <div class="login-btn__reallive login-btn__reallive__email" @click="emailLogin">
        <img class="login_icon__reallive" src="../../assets/img/email.png" />
        <span>{{$t('m.use_email_login')}}</span>
      </div>
    </div>
    <div class="login_box" v-if="!isTgWebApp && !isRealLive()">
      <login-sdk-facebook styleType="bar" />
      <login-sdk-google styleType="bar" />

      <div class="btn_split">
        <span class="btn_split_line"></span>
        <span class="btn_split_txt">{{$t('m.or')}}</span>
        <span class="btn_split_line"></span>
      </div>
      <div class="login_other">
        <!-- <login-sdk-apple /> -->
        <login-sdk-vk v-if="thisLangcountry=='ru'" />
        <login-sdk-twitter v-if="thisLangcountry!=='zh'" />
        <!-- <login-sdk-instagram v-if="thisLangcountry!=='zh'" /> -->
        <login-sdk-line v-if="thisLangcountry!=='zh'&&thisLangcountry!=='ru'" />

        <div class="img_box" @click="phoneLogin">
          <img class="login_other_img" src="../../assets/img/h5_login_icon05.png" />
        </div>
        <div class="img_box" @click="emailLogin">
          <img class="login_other_img" src="../../assets/img/h5_login_icon06.png" />
        </div>
      </div>
    </div>
    <div class="login_box" v-if="isTgWebApp && !isRealLive()">
      <div class="tglogin_box" @click="phoneLogin">
        <img class="login_other_img_tg" src="../../assets/img/h5_login_phone.png" />
        <span>{{$t('m.use_phone_login')}}</span>
      </div>
      <div class="tglogin_box" @click="emailLogin">
        <img class="login_other_img_tg" src="../../assets/img/h5_login_email.png" />
        <span>{{$t('m.use_email_login')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { myMixin } from "@/tools/mixins.js";
import LoginSdkFacebook from './LoginSdk/LoginSdkFacebook';
import LoginSdkGoogle from './LoginSdk/LoginSdkGoogle';
import LoginSdkTwitter from './LoginSdk/LoginSdkTwitter';
// import LoginSdkInstagram from './LoginSdk/LoginSdkInstagram';
import LoginSdkApple from './LoginSdk/LoginSdkApple';
import LoginSdkVK from './LoginSdk/LoginSdkVK';
import LoginSdkLine from './LoginSdk/LoginSdkLine';
import {isRealLive, isTelegramWebApp} from "../../util";
export default {
  name: "LoginSdk",
  mixins: [myMixin],
  components:{
    "login-sdk-facebook":LoginSdkFacebook,
    "login-sdk-google":LoginSdkGoogle,
    "login-sdk-twitter":LoginSdkTwitter,
    // "login-sdk-instagram":LoginSdkInstagram,
    "login-sdk-apple":LoginSdkApple,
    "login-sdk-vk":LoginSdkVK,
    "login-sdk-line":LoginSdkLine,
  },
  props: {
    thisLangcountry:{
      type:String,
      default:function(){
        return "en"
      }
    }
  },
  data() {
    return {
      // thisLangcountry:'en'
      isTgWebApp: false
    };
  },
  computed: {},
  mounted() {
    // this.initFacebook();
   // this.thisLangcountry = this.getLang1(2);
    this.isTgWebApp = isTelegramWebApp(this.$route);
  },
  methods: {
    isRealLive,
      phoneLogin(){
        this.$emit('isPhoneLogin', true)
      },

      emailLogin(){
        this.$emit('isEmailLogin', true)
      },

  },
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
.login_other_img_tg {
  width: 0.46rem;
  height: 0.46rem;
  position: absolute;
  top: 0.25rem;
  left: 0.5rem;
}
.logo_img {
  width: 1.3rem;
  height: 1.3rem;
}
.logo_img_reallive {
  width: 1.6rem;
  height: 1.89rem;
}
.login_box {
  margin: 1.2rem 0.67rem 0;
}
.tglogin_box{
    width: 100%;
    height: 0.96rem;
    font-size: 0.3rem;
    line-height: 0.96rem;
    position: relative;
    text-align: center;
    border-radius: 0.96rem;
    margin-bottom: 0.45rem;
    box-sizing: border-box;
    background-color: #fff;
    color: #333;
    box-shadow: 0 0.01rem 0.25rem 0 rgba(11, 79, 218, 0.13);
}
.btn_split {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.67rem;
  margin-bottom: 0.3rem;
}
.btn_split_line {
  width: 0.88rem;
  height: 1px;
  background-color: #d8d8d8;
}
.btn_split_txt {
  color: #999;
  font-size: 0.26rem;
  padding: 0 0.3rem;
}
.login_other {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-btn__reallive {
  width: 100%;
  height: 0.96rem;
  font-size: 0.3rem;
  line-height: 0.96rem;
  background-color: rgba(255, 97, 174, 1);
  position: relative;
  text-align: center;
  color: #fff;
  border-radius: 0.96rem;
  margin-bottom: 0.45rem;
  box-sizing: border-box;
  font-weight: 500;
}
.login-btn__reallive__email {
  color: #323335;
  background: rgba(255, 255, 255, 0.20);
  box-shadow: 0 3px 20px 0 rgba(255, 151, 202, 0.30);
}
.login_icon__reallive {
  width: 0.46rem;
  height: 0.46rem;
  position: absolute;
  top: 0.25rem;
  left: 0.5rem;
}
.fr .login-btn__reallive {
  padding: 0 0.3rem 0 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk.vue